import * as React from 'react';
import { Suspense, useMemo } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';
import {
  Spinner,
  archetypeLightTheme,
  GDSThemeProvider,
  loadTheme,
} from '@leagueplatform/genesis-core';
import { ErrorState } from '@leagueplatform/web-common-components';
import { useOnlineStatus } from '@leagueplatform/web-common';
import { StandaloneAuth } from '@leagueplatform/auth-standalone';
import { useLocalStorage } from 'usehooks-ts';
import { LOCAL_STORAGE_TENANT_ID_KEY } from 'constants/locale-storage';
import { getTenantSpecificConfig } from 'utils/get-tenant-specific-config';
import { TenantIdForm } from './components/tenant-id-form/tenant-id-form.component';
import AppRoutes from './components/app-routes.component';
import { ErrorPage } from './pages/Error404';
import { globalStyles } from './global-styles';

const theme = loadTheme(archetypeLightTheme, { useRems: true });

export function App() {
  const { isOnline } = useOnlineStatus();

  const [tenantId, setTenantId] = useLocalStorage(
    LOCAL_STORAGE_TENANT_ID_KEY,
    '',
  );

  const config = useMemo(() => getTenantSpecificConfig(tenantId), [tenantId]);

  globalStyles();

  return (
    <GDSThemeProvider theme={theme}>
      <ErrorBoundary fallback={<ErrorState error={null} />}>
        <Suspense fallback={<Spinner loading loadingText="Loading..." />}>
          {isOnline ? (
            <BrowserRouter>
              {config ? (
                <AppRoutes />
              ) : (
                <TenantIdForm
                  onValidSubmit={(newTenantId) => {
                    setTenantId(newTenantId);
                    StandaloneAuth.client.loginWithRedirect();
                  }}
                />
              )}
            </BrowserRouter>
          ) : (
            <ErrorPage />
          )}
        </Suspense>
      </ErrorBoundary>
    </GDSThemeProvider>
  );
}
